import { JSX, Show } from 'solid-js';
import { useLicense } from '../hooks/useLicense';

interface LicenseGateProps {
    type: string;
    fallback?: JSX.Element;
    children: JSX.Element;
}

export function LicenseGate(props: LicenseGateProps) {
    const has = useLicense(props.type);
    return <Show when={has()} fallback={props.fallback}>{props.children}</Show>;
}

export default LicenseGate;
